/**
 * Brand mark.
 * - `variant="mark"` (default) renders just the logo image at a fixed height.
 * - `variant="lockup"` renders the logo with the wordmark next to it.
 * - `size` is the logo height in px.
 *
 * The logo PNG lives in /app/frontend/public/brand/logo.png so we reference it
 * with a plain `/brand/logo.png` URL.
 */
export function Logo({ variant = "lockup", size = 48, className = "", textClassName = "", showText = true }) {
  const useText = variant === "lockup" && showText;
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src="/brand/logo.png?v=4"
        alt="Your Dog Days"
        height={size}
        style={{ height: size, width: size, objectFit: "contain", borderRadius: 6 }}
      />
      {useText && (
        <span className={`font-display font-black tracking-tighter ${textClassName}`}>
          Your Dog Days
        </span>
      )}
    </span>
  );
}

export default Logo;
